import { render } from "./SettingAppsView.vue?vue&type=template&id=49e4d851"
import script from "./js/settingAppsView.js?vue&type=script&lang=js&external"
export * from "./js/settingAppsView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__